module.exports = __webpack_public_path__ + "img/19_21.c14839c4.png";